module.exports = __webpack_public_path__ + "static/img/layout-right-shadow.aab894e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/business/layout-right-shadow.png
// module id = InSz
// module chunks = 0